import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import { HashRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import './css/index.css';

let store = configureStore();

// Checks every 10ms to see if config is loaded.
// Loads reactdom after config is loaded.
let interval = setInterval(function() {
  if (window.REACT_APP_MEMBER_API_HOST) {
    ReactDOM.render(
      <Provider store={store}>
        <HashRouter>
          <Route component={App}/>
        </HashRouter>
      </Provider>,
      document.getElementById('root')
    );

    clearInterval(interval);
  }
}, 10);




// WEBPACK FOOTER //
// ./src/index.js